import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  ${(props) =>
    props?.isContainer &&
    props?.isStatsPage &&
    `
    .basic-stats-container,
    .advanced-stats-container {
      min-height: unset;
    }
  
  `}
  ${(props) =>
    props?.isDNDTool &&
    `
    .basic-stats-container .data-object{
      width: 11% !important;
    }
    .advanced-stats-container .data-object{
      width: 16% !important;
    }
  `}
  .basic-stats-container,
  .advanced-stats-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
    background: #fff;
  }
  .data-object {
    width: ${(props) => (props.isStatsPage ? "16%" : "26%")};
    text-align: center;
  }
  .data-value {
    color: #555;
    font-weight: 700;
  }
  h2 {
    text-align: center;
    width: 100%;
    padding: 2rem 0;
    margin: 0;
    background: #fff;
  }
  .glosary-link {
    text-decoration: none;
    color: #000;
    font-weight: 700;
  }

  @media only screen and (min-width: 867px) {
    .data-object {
      width: ${(props) =>
        props.isStatsPage || props.isAdvancedStats ? "16%" : "11%"};
    }
  }
`;
